$ = require('jquery')
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Board = require 'models/board'
Card = require 'models/card'
List = require 'models/list'
ModelLoader = require 'db/model-loader'
Organization = require 'models/organization'
Promise = require 'bluebird'
React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('home')
DueDate = require 'views/home/due-date'
StickyBoxWaitForMount = require 'views/lib/sticky-box-wait-for-mount'
{ ContentSkeleton } = require './presentational/content-skeleton'
{ TeamCardsDueSection } = require './presentational/team-cards-due-section'
{ getScrollParent } = require('common/lib/dom/get-scroll-parent')

module.exports = class TeamCardsDueContainer extends React.Component
  displayName: 'TeamCardsDueContainer'

  constructor: (props) ->
    super props

    @unresolvedPromises = new Set()
    @fetchDueDateCards = @fetchDueDateCards.bind(@)
    @setGroupRef = @setGroupRef.bind(@)
    @onClickGroup = @onClickGroup.bind(@)

    @state = {
      dueDateCards: []
      loading: true
      selectedGroup: 'overdue'
    }

    @groupRefs = {}

  componentDidMount: ->
    @cancelOnUnmount(new Promise((resolve) -> ModelLoader.waitFor('boardsData', resolve))).then =>
      @fetchDueDateCards().then (dueDateCards) =>
        @setState
          dueDateCards: dueDateCards
          loading: false
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e
        @setState
          loading: false

  componentWillUnmount: ->
    @unresolvedPromises.forEach((promise) -> promise.cancel())

  cancelOnUnmount: (promise) =>
    promise.cancellable()
    @unresolvedPromises.add(promise)
    promise.then => @unresolvedPromises.delete(promise)

    return promise

  setGroupRef: (groupName, groupRef) ->
    @groupRefs[groupName] = groupRef

  onClickGroup: (groupName) ->
    @setState(selectedGroup: groupName)
    @scrollIntoView(@groupRefs[groupName])

  scrollIntoView: (el) ->
    if !el
      return true

    $(getScrollParent(el)).animate({
      scrollTop: el.offsetTop - 8,
    })

  fetchDueDateCards: ->
    { modelCache, orgId } = @props

    @cancelOnUnmount(ModelLoader.loadUpNext())
      .then (response) =>
        dueDateCards = response.upNext.map (upNextItem) =>
          card = _.findWhere response.cards, id: upNextItem.data.idCard
          list = _.findWhere response.lists, id: card.idList
          board = _.findWhere response.boards, id: card.idBoard
          item = upNextItem.items[0]
          action = _.findWhere response.actions, id: item.data.idAction
          memberCreator = _.findWhere response.members, id: action?.idMemberCreator
          org = _.findWhere response.organizations, id: board.idOrganization

          action?.memberCreator = memberCreator
          board.organization = org
          card.list = list
          card.board = board
          item.data = { action }
          new Card(card, modelCache: modelCache)

          return {
            id: upNextItem.id
            card: modelCache.get('Card', card.id)
            list: new List(list, modelCache: modelCache)
            board: new Board(board, modelCache: modelCache)
            org: new Organization(org, modelCache: modelCache)
            item
          }

        return dueDateCards
          .filter((dueDateCard) => dueDateCard.item.type == 'dueSoon')
          .filter((dueDateCard) => dueDateCard.org.id == orgId)

      .catch ApiError.Server, (e) ->
        console.error e
        []
      .catch ApiError.BadRequest, (e) ->
        console.error e
        []
      .catch (e) =>
        if e instanceof Promise.CancellationError
          throw e

        console.error e
        []

  removeDueDateCard: (dueDateId) =>
    @setState (prevState) ->
      dueDateCards: prevState.dueDateCards.filter((dueDateCard) -> dueDateCard.id != dueDateId)

  renderDueDate: (dueDateCard) =>
    { id, card, list, board, org, item } = dueDateCard
    { modelCache } = @props

    React.createElement DueDate, {
      board
      card
      id
      item
      key: id
      list
      modelCache
      org
      @removeDueDateCard
    }

  getDueDateOf: (dueDateCard) =>
    return (dueDateCard.card.getDueDate() || new Date()).getTime()

  render: t.renderable ->
    { orgName, orgId } = @props
    { dueDateCards, loading, selectedGroup } = @state

    if loading
      t.div '.home-due-dates-loading-container', =>
        t.tag ContentSkeleton
    else
      t.div '.home-due-dates-container', =>
        t.tag TeamCardsDueSection, {
          dueDateCards
          @getDueDateOf
          now: Date.now()
          @onClickGroup
          @renderDueDate
          selectedGroup
          @setGroupRef
          StickyBoxWaitForMount
        }



// WEBPACK FOOTER //
// ./app/scripts/views/home/team-cards-due-container.coffee